/* eslint-disable */
import { useStore } from '../core/useStore';
import { v4 as uuidv4 } from 'uuid';
import { regenTokenifExpired } from './utilityFunctions';

export default function browseMockfaqhandler() {
  const setFaqsMockdata = (data) => useStore.setState({ faqsItems: data });
  const contentURL = process.env.REACT_APP_CONTENT_SERVER || '/api-content';
  const getFaqsMockData = async () => {
    const anontoken = regenTokenifExpired();
    const faqmockJsonData = anontoken.then(async (token) => {
      return await fetch(`${contentURL}/portal-content?resourcePath=faqs&resourceName=config.json`, {
        headers: {
          Authorization: token,
          uuid: uuidv4(),
          audience: 'public',
        },
        credentials: 'omit',
      })
        .then((x) => x.json())
        .then((data) => {
          setFaqsMockdata(data.faqs);
        })
        .catch((e) => {
          console.log(e);
        });
    });
    return faqmockJsonData;
  };
  return {
    getFaqsMockData,
  };
}
